import React, { useEffect, useRef, useState } from "react";
import CustomerBalancesPrint from "./customerBalancesPrint";
import UpdateBalanceTable from "./updateBalanceTable";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";
import toast from "react-hot-toast";

function UpdateBalance() {
  const [refreshTable, setRefreshTable] = useState(false);
  return (
    <>
      <CustomerBalancesPrint />
      <CustomerBalanceCSVFile setRefreshTable={setRefreshTable} />
      <UpdateBalanceTable key={refreshTable ? "refresh" : "default"} />
    </>
  );
}

export default UpdateBalance;

function CustomerBalanceCSVFile({ setRefreshTable }) {
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [upLoading, setUpLoading] = useState(false);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [tokenExpired, setTokenExpired] = useState(false);

  const downloadCSV = async () => {
    if (loading || upLoading) return;
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/ledger/download`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        setTokenExpired(true);
        return;
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const currentDate = new Date().toLocaleDateString(); // Format as required (e.g., MM/DD/YYYY)
        link.href = downloadUrl;
        link.download = `Customer Balances and Sales [${currentDate}].xls`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        toast.success("File downloaded successfully", {
          style: {
            border: "1px solid #021F7E",
            padding: "16px",
            color: "#0573E3",
          },
          iconTheme: {
            primary: "#021F7E",
            secondary: "#fff",
          },
          duration: 6000,
        });
      } else {
        const data = await response.json();
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#fff",
          },
          duration: 6000,
        });
        throw new Error("Failed to export report.", data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    console.log("clicked btn", selectedFile);
    if (selectedFile) {
      if (upLoading || loading) return;
      setUpLoading(true);

      const formData = new FormData();
      formData.append("file", selectedFile);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/ledger/upload`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
          return;
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }

          const data = await response.json();
          if (data.status === 200) {
            setRefreshTable((prev) => !prev);
            toast.success("File uploaded successfully", {
              style: {
                border: "1px solid #021F7E",
                padding: "16px",
                color: "#0573E3",
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#0573E3",
              },
            });
            if (fileInputRef.current) fileInputRef.current.value = "";
          }
        } else {
          const data = await response.json();
          toast.error(data.message, {
            style: {
              border: "1px solid #FE0000",
              padding: "16px",
              color: "#FE0000",
            },
            iconTheme: {
              primary: "#fff",
              secondary: "#FE000099",
            },
          });
          setUpLoading(false);
          if (fileInputRef.current) fileInputRef.current.value = "";
          throw new Error("Failed to upload file");
        }
      } catch (err) {
        if (fileInputRef.current) fileInputRef.current.value = "";
        console.error(err);
      } finally {
        setUpLoading(false);
      }
    } else {
      toast.error("uploading cancelled", {
        style: {
          border: "1px solid #FE0000",
          padding: "16px",
          color: "#FE0000",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#FE000099",
        },
      });
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (tokenExpired) {
      dispatch(clearCredentials());
      return;
    }
  }, [dispatch, tokenExpired]);

  return (
    <>
      <div
        className="whiteBgDiv UserManagementPadding"
        style={{ marginTop: "25px" }}
      >
        <div className="mainHeading">
          Update Balances and Sales Data Locally
        </div>
        <div
          className="formHeading UserManagementpage mt-2 "
          style={{ fontSize: "18px", fontWeight: "400", marginBottom: "34px" }}
        >
          Download the latest balances and sales files, update your Excel sheets
          with precise data, and ensure all entries are accurate and Upload.
        </div>
        <div className="d-flex align-items-end justify-content-between flex-wrap gap-3">
          <button className="grayBtn" onClick={downloadCSV}>
            {loading ? "Downloading ..." : "Download"}
          </button>
          <div>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={handleFileChange}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
            <button className="colorBtn" onClick={handleButtonClick}>
              {upLoading ? "Uploading ..." : "Upload"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
